import * as types from 'constants/actionTypes';
import * as operationsApi from 'api/operationsApi';
import { beginAjaxCall, ajaxCallError } from './ajaxCallActions.js';

export function getJobStandards() {
  return function(dispatch) {
    dispatch(beginAjaxCall());
    return operationsApi
      .getJobStandards()
      .then(
        response => dispatch(getJobStandardsSuccess(response)),
        error => dispatch(ajaxCallError())
      );
  };
}

function getJobStandardsSuccess(response) {
  return {
    type: types.GET_JOB_STANDARDS_SUCCESS,
    jobStandards: response.data || []
  };
}
